import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from './Common/Button';

export default function Welcome({title}) {

    const handleNav = () => {
        navigate('/login')
    }
    const handleNavRegister = () => {
        navigate('/register')
    }

    let navigate = useNavigate();
    return (
        <div>
            <div className="heading-container">
                <h3>
                    WELCOME TO <br/> MY REACTJS APP WITH FIREBASE LOGIN AND HOSTED IN CLOUDFLARE PAGES
                </h3>
            </div>
            <Button handleAction={handleNav} title={title}/>
            <br/>
            <br/>
            <Button handleAction={handleNavRegister} title="Register"/>
        </div>
    )
}